(() => {
  if (window.__evHubEvents) return;
  window.__evHubEvents = true;
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    const root = target?.closest('[data-editorial-shop]');
    if (!root) return;
    let name, detail = { hub_name: 'tech_formal' };
    if (target.hasAttribute('data-gender') || target.hasAttribute('data-category')) {
      name = 'ev_hub_filter';
      detail.filter_type = target.hasAttribute('data-gender') ? 'gender' : 'category';
      detail.filter_value = target.dataset.gender || target.dataset.category;
    } else if (target.hasAttribute('data-shop-more')) {
      name = 'ev_hub_show_more';
    } else if (target.closest('[data-shop-editorial]')) {
      name = 'ev_hub_editorial';
      detail.destination_path = new URL(target.href, location.origin).pathname;
    } else if (target.classList.contains('grid-product__link')) {
      name = 'ev_hub_product';
      detail.destination_path = new URL(target.href, location.origin).pathname;
    }
    if (!name) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (privacy?.analyticsProcessingAllowed && !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag === 'function') window.gtag('event', name, detail);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...detail });
    }
  });
})();
